import countries from '@/data/countries';

const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
const byCode = new Map(countries.map(country => [country.code, country]));
const names = new Map(countries.flatMap(country => [[normalize(country.name), country], [normalize(country.code), country]]));
const aliases = {
  unitedstatesofamerica: 'US', usa: 'US', uk: 'GB', greatbritain: 'GB',
  southkorea: 'KR', northkorea: 'KP', russia: 'RU', vietnam: 'VN',
  czechia: 'CZ', turkiye: 'TR', ivorycoast: 'CI',
};
Object.entries(aliases).forEach(([name, code]) => names.set(name, byCode.get(code)));
const localizations = new Map();
function localization(locale) {
  if (localizations.has(locale)) return localizations.get(locale);
  const labels = new Map();
  const lookup = new Map();
  let formatter;
  try { formatter = new Intl.DisplayNames([locale], { type: 'region' }); } catch { /* Keep the existing country names if the locale is unsupported. */ }
  countries.forEach(country => {
    const label = formatter?.of(country.code) || country.name;
    labels.set(country.code, label);
    lookup.set(normalize(label), country);
  });
  const result = { labels, lookup };
  localizations.set(locale, result);
  return result;
}

// Only known countries get a flag. Unknown report labels stay readable as sent.
export function countryDetails(value, locale = 'en') {
  const raw = String(value || '').trim();
  const localized = localization(locale);
  const country = names.get(normalize(raw)) || localized.lookup.get(normalize(raw)) || localization('en').lookup.get(normalize(raw));
  return country ? { code: country.code, name: localized.labels.get(country.code), flag: country.flag }
    : { code: '', name: raw || '—', flag: '' };
}

export function countrySearchText(value, locale = 'en') {
  const country = countryDetails(value, locale);
  return normalize(`${value || ''} ${country.name} ${country.code}`);
}
export const normalizeCountrySearch = normalize;
